// Global
import { useI18n } from 'next-localization';
import { useCallback } from 'react';

const useDictionary = () => {
  const i18n = useI18n();

  // Get value from Sitecore Dictionary. Uses fallback if defined, else returns an empty string
  const getDictionaryValue = useCallback(
    (key: string, fallback?: string) => i18n.t(key) || fallback || '',
    [i18n]
  );

  return {
    getDictionaryValue,
  };
};

export default useDictionary;
